import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { CookieUtilWrapperService } from 'src/app/services/cookie-util-wrapper.service';
import { triggerAnalyticsEvent } from 'src/app/utils/analytics/trigger-analytics';

@Component({
  selector: 'app-paas-saas-switch',
  templateUrl: './paas-saas-switch.component.html',
  styleUrls: ['./paas-saas-switch.component.scss'],
})
export class PaasSaasSwitchComponent {
  @ViewChild('versionSwitchConfirmation', { static: true })
  private versionSwitchConfirmation: TemplateRef<any>;
  versionBadge = JSON.stringify({
    severity: 'success',
    customText: 'Switch to Old UI',
    // background: '#ecebff',
    // color: '#645df6',
    showImg: false,
    imgUrl: '',
    badgeClass: 'p-2 mb-0 cursor-pointer text-decoration-underline',
    textCase: 'false',
  });
  loading: boolean = false;

  constructor(
    private cookieService: CookieUtilWrapperService,
    private dialogService: NbDialogService,
  ) {}

  openSwitchConfirmationPopup() {
    triggerAnalyticsEvent('SWITCH_TO_OLD_UI_BADGE_CLICK');
    this.dialogService.open(this.versionSwitchConfirmation, {
      context: {},
    });
  }
  switchV1() {
    this.loading = true;
    triggerAnalyticsEvent('SWITCH_TO_OLD_UI_CONFIRM');
    this.cookieService.set('oldExperience', 'true', undefined, '/');
    window.location.href = '/capc/home';
  }
  onClickHandleCancel(ref: any) {
    triggerAnalyticsEvent(`SWITCH_TO_OLD_UI_CANCEL`);
    ref?.close();
  }
}
